import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { handleConstrainElements } from "./constrainElements";
import {
  handleRemoveConstraintRequest,
  handleRemoveConstraintSuccess,
  handleRemoveConstraintFailure,
} from "./removeConstraint";
import { handleEditConstraint } from "./editConstraint";
import { initialState } from "./initialState";
import { propagateEvent } from "./propagateEvent";

const reduceGantt = createStateReducer(
  initialState,
  {
    [events.constrainElementsSucceeded]: handleConstrainElements,
    [events.removeConstraintRequested]: handleRemoveConstraintRequest,
    [events.removeConstraintSucceeded]: handleRemoveConstraintSuccess,
    [events.removeConstraintFailed]: handleRemoveConstraintFailure,
    [events.editConstraintSucceeded]: handleEditConstraint,
  },
  propagateEvent,
);

export { reduceGantt };
